<template>
  <div class="calculator-inputs">
    <div :class="firstRowClassName">
      <div class="calc-container" v-if="isEU">
        <calculator-radio :title="this.$getContent('client_type' , 'Client')" inputName="clientType" :options="clientTypes" :inputDetails="inputDetails" :changeHandler="setAssetsList"></calculator-radio>
      </div>
      <div class="calc-container">
        <calculator-select :title="this.$getContent('account_type' , 'Account Type')" selectName="accountType" :options="accountTypes" :inputDetails="inputDetails" :changeHandler="setAssetsList"></calculator-select>
      </div>
    </div>
    <div class="flex-wrapper">
      <div class="calc-container">
        <calculator-select :title="this.$getContent('account_currency' , 'Account Currency')" selectName="feeCurrency" :options="currencies" :inputDetails="inputDetails" :changeHandler="emptyHandler"></calculator-select>
      </div>
      <div class="calc-container">
        <calculator-select :title="this.$getContent('asset' , 'Asset')" selectName="asset" :options="assets" :inputDetails="inputDetails" :changeHandler="emptyHandler"></calculator-select>
      </div>
    </div>
    <div class="flex-wrapper">
      <div class="calc-container">
        <calculator-number-input :label="this.$getContent('trade_size' , 'Trade Size (lots)')" :inputDetails="inputDetails" inputName="tradeSize"></calculator-number-input>
      </div>
      <div class="calc-container">
        <calculator-number-input :label="this.$getContent('position_duration' , 'Position Duration')" :inputDetails="inputDetails" inputName="positionDuration"></calculator-number-input>
      </div>
    </div>
    <div class="flex-wrapper calc-buttons">
      <button class="calculator-action-btn" data-action="sell" :data-selected="isButtonSelected('sell')" @click="setAction">{{this.$getContent('sell' , 'Sell')}}</button>
      <button class="calculator-action-btn" data-action="buy" :data-selected="isButtonSelected('buy')"  @click="setAction">{{ this.$getContent('buy' , 'Buy') }}</button>
    </div>
    <button class="calculate-submit" @click="sendCalculation" :disabled="formState=='inComplete'">{{ this.$getContent('calculate' , 'Calculate') }}</button>
  </div>

</template>

<script>
	import calculatorSelect from './calculatorSelect.vue';
	import calculatorNumberInput from './calculatorNumberInput.vue';
	import calculatorRadio from './calculatorRadio.vue';
	export default {
    name: "calculatorInputs",
    components: {
      calculatorSelect,
      calculatorNumberInput,
      calculatorRadio
    },
		data() {
			return {
        currencies : [{value : 'initial' , 'label' : this.$getContent('select_currency_placeholder' , 'Select Currency')} , {'value' : 'USD' , 'label' : 'USD - $'} , {'value' : 'GBP' , 'label' : 'GBP - £'} , {'value' : 'RUB' , 'label' : 'RUB - ₽'} , {'value' : 'EUR' , 'label' : 'EUR - €'} , {'value' : 'CHF' , 'label' : 'CHF - ₣'} , {'value' : 'TRY' , 'label' : 'TRY - ₺'} ,{'value' : 'ZAR' , 'label' : 'ZAR - R'} ,{'value' : 'JPY' , 'label' : 'JPY - ¥'}],
        accountTypes: this.getAccountTypesOptions(),
        clientTypes: this.getClientTypesOptions(),
        assets : this.buildCurrencyList(),
        firstRowClassName: this.isEU ? 'flex-wrapper' : 'flex-wrapper center'
			}
		},
		methods : {
      getAccountTypesOptions() {
        let assets_keys = Object.keys(siteAssetsConfig.items) || [];
        let account_types = [];
        let options = [];
        for (let i = 0; i < assets_keys.length; i++) {
          let account_type = this.isEU ? assets_keys[i].split('_')[1] : assets_keys[i];
          if (account_types.indexOf(account_type) == -1) {
            account_types.push(account_type);
          }
        }
        for (let i = 0; i < account_types.length; i++) {
          let translatin_key = 'account_type_' + account_types[i].toLowerCase();

          // initial value
          if (i == 0) {
            options.push({
              value: account_types[i],
              label: this.$getContent(translatin_key, account_types[i])
            });
          }
          options.push({
            value: account_types[i],
            label: this.$getContent(translatin_key, account_types[i])
          });
        }
        return options;
      },
      getClientTypesOptions() {
        let assets_keys = Object.keys(siteAssetsConfig.items) || [];
        let client_types = [];
        let options = [];
        for (let i = 0; i < assets_keys.length; i++) {
          let client_type = assets_keys[i].split('_')[0];
          if (client_types.indexOf(client_type) == -1) {
            client_types.push(client_type);
          }
        }
        for (let i = 0; i < client_types.length; i++) {
          let translatin_key = 'client_type_' + client_types[i].toLowerCase();

          options.push({
            value: client_types[i],
            label: this.$getContent(translatin_key, client_types[i])
          });
        }
        return options;
      },
      emptyHandler(){},
			buildCurrencyList(){
        let list = [] ;
        let assets = this.getAssets();
        let currentAssetId = this.inputDetails.asset;
        let hasCurrentAtList = false;

        list.push({
          value: 'initial',
          label: this.$getContent('select_asset_placeholder' , 'Select Asset')
        });

				for (let i = 0; i < assets.length; i++) {
					if (assets[i].display == 1) {
						list.push({
              value: assets[i].asset_id,
              label:assets[i].asset_name
            });

            if (currentAssetId == assets[i].asset_id && !hasCurrentAtList) {
              hasCurrentAtList = true;
            }
					}
        }
        
        if (!hasCurrentAtList) {
          this.inputDetails.asset = '';
        }

				return list;
      },
      getAssets() {
        let clientType = this.inputDetails['clientType'] || '';
        let accountType = this.inputDetails['accountType'] || '';
        let configKey = accountType;
        if (this.isEU) {
          configKey = clientType + '_' + accountType;
        }
        return siteAssetsConfig.items[configKey] || [];
      },
      setAssetsList(){
        this.assets = this.buildCurrencyList();
      },
			setAction(event){
				let button = event.target ;
				this.inputDetails.action =  button.getAttribute('data-action') ;
			},
			sendCalculation(){
				this.submitState = 'after' ;
				this.$emit('sendCalculation') ;
			} ,
			isButtonSelected(action){
				if(this.inputDetails.action == action){
					return 'true';
				}
				return 'false' ;
			}
		},
		mounted: function() {
      this.assets = this.buildCurrencyList();
		},

		props : ['inputDetails', 'formState', 'isEU']
	}
</script>

<style lang="scss">
  .calculator-inputs {
    padding: 4% 6% 1%;
  }
  .flex-wrapper{
    display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox;      /* TWEENER - IE 10 */
    display: -webkit-flex;     /* NEW - Chrome */
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 480px) {
      flex-wrap: wrap;
    }

    &.center{
      justify-content: center;
    }
  }
  .calc-buttons{
    justify-content: center;
    margin-top: 20px;
    @media (max-width: 480px){
      justify-content: space-between;
    }
    button{
      height: 50px;
      border-radius: 4px;
      border:none;
      background-color: #353535;
      color:#fff;
      font-size: 18px;
      font-weight: 500;
      &:focus{
        outline: 0;
      }

    }
    button[data-action="buy"]{
      box-shadow: inset 0 -1px 0 0 #37e275;
      &:hover , &[data-selected="true"]{
        box-shadow: 0 3px 24px 1px rgba(68, 233, 137, 0.28);
        background-image: linear-gradient(to top, #46ac53, #30ff88);
        color: #212121;
      }
    }
    button[data-action="sell"]{
      margin-right: 2%;
      box-shadow: inset 0 -1px 0 0 #eb1c23;
      background-color: #353535;
      .rtl &{
        margin-right: 0;
        margin-left: 2%;
      }
      &:hover , &[data-selected="true"]{
        box-shadow: 0 3px 24px 1px rgba(233, 68, 68, 0.28);
        background-image: linear-gradient(to top, #ff3030, #e54c4c);
      }

      @media (max-width: 480px){
        margin-right: 0;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/calculatorInputs/calculatorInputs.vue